import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isContentPermissionError", "handleConfirm", "disabled", "disabledTooltipTitle"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { allowSave, validateSelectedOptions } from 'sales-content-partitioning/utils/validation';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignmentPanelSaveButton = props => {
  const {
      isContentPermissionError,
      handleConfirm,
      disabled,
      disabledTooltipTitle
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (isContentPermissionError) {
    return null;
  }
  const tooltipString = disabled ? disabledTooltipTitle : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "salesContentPartitioning.assignmentPanel.footer.selectSomeTeamOrUser"
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disabled && validateSelectedOptions(otherProps),
    title: tooltipString,
    children: /*#__PURE__*/_jsx(LoadingButton, {
      disabled: disabled || !allowSave(otherProps),
      failed: false,
      loading: false,
      onClick: handleConfirm,
      use: "primary",
      "data-test-id": "save-sales-content-permissions-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "salesContentPartitioning.assignmentPanel.footer.save"
      })
    })
  });
};
export default AssignmentPanelSaveButton;